import { Attivazione } from "./../../../../models/attivazione";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "title3",
  templateUrl: "./title3.component.html",
  styleUrls: ["./title3.component.scss"]
})
export class Title3Component implements OnInit {
  @Input() attivazione: Attivazione;
  @Output() reset = new EventEmitter();
  public titleRadioForm: FormGroup;
  public day: string = "";
  public month: string = "";
  public year: string = "";

  constructor() {}

  ngOnInit() {
    this.titleRadioForm = new FormGroup({
      usufruct: new FormControl(this.attivazione.usufruct, {
        validators: [Validators.required]
      })
    });
  }

  public resetform() {
    this.reset.emit(null);
    this.titleRadioForm.reset();
  }

  checkDate() {
    if (this.year != "" && this.month != "" && this.day != "")
      this.attivazione.leaseDate = `${this.month}/${this.day}/${this.year}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/forms/title3/title3.component.ts